import { container } from "assets/jss/material-kit-react.js";
import typographyStyle from "./typographyStyle";

const carouselStyle = {
  section: {
    padding: "70px 0",
  },
  container,
  typographyStyle,
  marginAuto: {
    marginLeft: "auto !important",
    marginRight: "auto !important",
  },
};

export default carouselStyle;
